export function getLocalStorageItemCaseInsensitive(targetKey) {
  try {
    const normalizedTargetKey = targetKey.toLowerCase();

    for (let i = 0; i < localStorage.length; i += 1) {
      const key = localStorage.key(i);
      if (key && key.toLowerCase() === normalizedTargetKey) {
        return localStorage.getItem(key) || "";
      }
    }
  } catch (error) {
    console.error("Failed to read localStorage item.", error);
    return "";
  }

  return "";
}
